import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { HecResponse } from '../../shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';

@Component({
  selector: 'kt-contact-form-detail',
  templateUrl: './contact-form-detail.component.html',
  styleUrls: ['./contact-form-detail.component.css']
})
export class ContactFormDetailComponent implements OnInit {
  @ViewChild('contactDetailsForm', { static: false }) contactDetailsForm: NgForm;
  @Input('dropdownList') dropdownList: any;
  @Input('addressDetailsData') addressDetailsData : any;
  public addressFormData: any;
  public addresssListArray: any = [];
  public selectedCountryId:any;
  public isAlertVisible:boolean = false;
  constructor(private sharedServices:SharedService, private cdr:ChangeDetectorRef) { }

  ngOnInit() {
    // console.log(this.addressDetailsData)
    if(this.addressDetailsData.countryId){
      this.getCitiesByCountry(this.addressDetailsData.countryId);
      this.getPostalCodesByCity(this.addressDetailsData.cityId);
    }
  }

  public getDistrictByCity(cityId) {
    if (cityId != undefined) {
      this.sharedServices.getDistrictsByCityId(cityId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.dropdownList.districtList = res.data;
            this.cdr.detectChanges();
          }
          else {

          }
        },
        (err) => {
        }
      )
    }
  }

  public getPostalCodesByCity(cityId) {
    this.getDistrictByCity(cityId);
    if (cityId != undefined) {
      this.sharedServices.getPostalCodeByCityId(cityId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.dropdownList.postalCodesList = res.data;
            this.cdr.detectChanges();

          }
          else {

          }
        },
        (err) => {

        }
      )
    }
  }

  public getCitiesByCountry(countryId) {
    this.selectedCountryId = countryId;
    if (countryId != undefined) {
      this.sharedServices.getCitiesByCountryId(countryId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.dropdownList.cityList = res.data;
            // console.log(this.dropdownList)
            this.cdr.detectChanges();
          } else {

          }
        },
        (err) => {

        }
      )
    }
  }

}
